import React from "react";
import { Link } from "react-router-dom";
import "./TermsOfUse.css";
import DefaultLayout from "../../layouts/DefaultLayout";

const TermsOfUse = () => {
  return (
    <>
      <DefaultLayout>
        <div>
          <div className="termsofuse-container">
            <div className="termsofuse-section">
              <div className="termsofuse-header">
                <h5 className="termsofuse-h5">Terms of Use</h5>
              </div>

              <div className="document-section">
                <div className="termsofuse-document">
                  <h5 className="document-heading">
                    Document effective September 1, 2021
                  </h5>
                  <p className="effective-document-p">
                    By visiting and signing up on this site, you accept our
                    terms and conditions of service.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">1. Introduction</h5>
                  <p className="effective-document-p">
                    OVest is an automated savings and investment platform
                    available online and through mobile applications.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">1.1 Purpose</h5>
                  <p className="effective-document-p">
                    We offer an automated savings and investment service. As our
                    Client, we will manage your savings and investment on your
                    behalf in a very low cost manner to maximize your returns.
                    By using our website and mobile applications, you enter into
                    a series of legally binding agreements. You also agree to
                    our Privacy Policy which covers how we collect, use, share
                    and store your personal information.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">1.2 Agreement</h5>
                  <p className="effective-document-p">
                    When you access our website at{" "}
                    <Link to="/">www.myovest.com </Link>
                    and/or our mobile applications ("our website" (which
                    includes our blog), "our app" or “OVest") as a User and
                    Client, you're agreeing to be bound by the following Terms
                    of Use. Please therefore take the time to read the following
                    binding Terms of Use below: For the purpose of this
                    agreement a User is an individual who uses our website or
                    mobile application to evaluate our service, or for
                    educational purposes and a Client is an individual who signs
                    up on OVest that entitles the Client to have her or his
                    savings and or investment portfolio managed by OVest. This
                    Agreement, as well as the Privacy Policy applies to both
                    Users and Clients. If you elect to become a Client, you will
                    be subject to these Terms of Use, our Client Agreement, our
                    Privacy Policy and any additional terms to which you agree
                    when you create and fund a savings and or investment plan.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">2. Obligations</h5>
                  <p className="effective-document-p">
                    You must be 18 or older to access our website or mobile
                    applications.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">2.1 Eligibility</h5>
                  <p className="effective-document-p">
                    OVest is intended solely for individuals who are 18 or
                    older. Any access to or use of OVest by anyone under 18 is
                    unauthorized, unlicensed, and in violation of these Terms of
                    Use. By accessing or using OVest, you represent and warrant
                    that you are 18 or older.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">2.2 Your Access</h5>
                  <p className="effective-document-p">
                    In order to access certain features of OVest, you must
                    register to create an account ("User Account"). When you
                    register, you will be asked to choose a password, which you
                    will be required to use to access your User Account. OVest
                    has physical, electronic and procedural safeguards that
                    comply with regulatory standards to guard Users' and
                    Clients' non-public personal information (see Privacy
                    Policy). You are responsible for safeguarding your password
                    and other User Account information. You agree not to
                    disclose your password to any third party and you will
                    notify OVest immediately if your password is lost or stolen
                    or if you suspect any unauthorized use of your User Account.
                    As a User you agree that you shall be solely responsible for
                    any activities or actions under your User Account, whether
                    or not you have authorized such activities or actions. You
                    agree that the information you provide to us on account
                    registration through our website or mobile applications will
                    be true, accurate, current, and complete. If you wish to
                    develop enhancements to the OVest service then you must do
                    so via our "Partner Program" API. As used in these Terms,
                    "APIs" means programmatic web APIs and associated tools and
                    documentation that provide access to certain data displayed
                    on our website or in our mobile applications. Access to our
                    APIs requires you meet our Partner Program eligibility
                    criteria and enter into a signed partnership agreement with
                    OVest. You may not scrape or copy information through any
                    means (including crawlers, browser plugins and add-ons, and
                    any other technology or manual work) as explained in Section
                    6.2. If you wish to learn more about becoming a Partner,
                    please contact{" "}
                    <a href="mailto:hello@myovest.com">
                      hello@myovest.com.
                    </a>
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    2.3 Alerts, Notifications and Service Communications
                  </h5>
                  <p className="effective-document-p">
                    By creating a User Account, you automatically sign up for
                    various types of alerts via e-mail and mobile notification.
                    We never include your password in these communications, but
                    we may include your name, or email address and information
                    about your portfolio(s) if you are a Client. Anyone with
                    access to your e-mail or mobile device will be able to view
                    these alerts. You may unsubscribe from marketing oriented
                    emails at any time.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    3. Disclaimer and Limit of Liability
                  </h5>
                  <p className="effective-document-p">
                    OVest cannot be held responsible for any financial insights
                    or recommendations provided to users.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    3.1. For a User who is not a Client
                  </h5>
                  <p className="effective-document-p">
                    You understand and acknowledge that the investment results
                    you could obtain from investment information and financial
                    insights provided by OVest cannot be guaranteed and that
                    OVest cannot be held responsible. All investments entail a
                    risk of loss and that you may lose money. Investment
                    management services may be offered to individuals who become
                    clients, at the sole discretion of OVest. Your election to
                    engage our savings and investment services are subject to
                    your explicit enrollment and acceptance of this Terms of
                    Use.. You agree and understand that your use of OVest is for
                    educational purposes only and is not intended to provide
                    legal, tax or financial planning advice. You agree as a User
                    that you are responsible for your own investment research
                    and investment decisions, that OVest is only one of many
                    tools you may use as part of a comprehensive investment
                    education process, that you should not and will not rely on
                    OVest as the primary basis of your investment decisions and,
                    except as otherwise provided for herein, OVest will not be
                    liable for decisions/actions you take or authorize third
                    parties to take on your behalf based on information you
                    receive as a User of OVest or information you otherwise see
                    on our website.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    3.2. Disclaimer Warranties
                  </h5>
                  <p className="effective-document-p">
                    Your use of OVest's Website, and the personal information
                    you provide is at your sole discretion. OVest's Website and
                    all materials, information, products and services included
                    therein, are provided on an AS IS and AS AVAILABLE basis
                    without warranties of any kind from OVest.
                  </p>
                  <p className="effective-document-p">
                    OVEST EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND,
                    EXPRESS, IMPLIED OR STATUTORY, RELATING TO OVEST'S WEBSITE,
                    CONTENT AND/OR USER INFORMATION, INCLUDING WITHOUT
                    LIMITATION THE WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS
                    FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT OF PROPRIETARY
                    RIGHTS, COURSE OF DEALING OR COURSE OF PERFORMANCE. OVEST
                    DISCLAIMS ANY WARRANTIES, EXPRESS OR IMPLIED:
                  </p>
                  <p className="effective-document-p">
                    1. REGARDING THE AVAILABILITY, SECURITY, ACCURACY,
                    RELIABILITY, TIMELINESS AND PERFORMANCE OF OVEST'S WEBSITE,
                    CONTENT AND/OR USER INFORMATION;
                  </p>
                  <p className="effective-document-p">
                    2. THAT OVEST'S WEBSITE WILL BE ERROR-FREE OR THAT ANY
                    ERRORS WILL BE CORRECTED;
                  </p>
                  <p className="effective-document-p">
                    3. THAT OVEST'S WEBSITE WILL BE FREE FROM ELECTRONIC
                    VIRUSES; OR
                  </p>
                  <p className="effective-document-p">
                    4. REGARDING THE PERFORMANCE OF OR ACCURACY, QUALITY,
                    CURRENCY, COMPLETENESS OR USEFULNESS OF ANY INFORMATION
                    PROVIDED BY OVEST ON ITS WEBSITE INCLUDING BUT NOT LIMITED
                    TO INFORMATION OBTAINED THROUGH SOCIAL MEDIA.
                  </p>
                  <p className="effective-document-p">
                    No advice or information, whether oral or written, obtained
                    by you from OVEST's Website, shall create any warranty not
                    expressly stated in this Agreement. If you choose to rely on
                    such information, you do so solely at your own risk.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    3.3. Limitation of Liability
                  </h5>
                  <p className="effective-document-p">
                    IN NO EVENT SHALL OVEST OR ANY OF ITS OFFICERS, DIRECTORS,
                    EMPLOYEES, OR AGENTS BE LIABLE TO YOU FOR ANY DAMAGES
                    WHATSOEVER, INCLUDING WITHOUT LIMITATION INDIRECT,
                    INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES,
                    ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF OVEST,
                    CONTENT AND/OR USER INFORMATION, INCLUDING BUT NOT LIMITED
                    TO THE QUALITY, ACCURACY, OR UTILITY OF THE INFORMATION
                    PROVIDED AS PART OF OR THROUGH OVEST OR FOR ANY INVESTMENT
                    DECISIONS MADE ON THE BASIS OF SUCH INFORMATION, WHETHER THE
                    DAMAGES ARE FORESEEABLE AND WHETHER OR NOT OVEST HAS BEEN
                    ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING
                    LIMITATION OF LIABILITY SHALL APPLY TO THE FULLEST EXTENT
                    PERMITTED BY LAW IN THE APPLICABLE JURISDICTION AND IN NO
                    EVENT SHALL OVEST'S CUMULATIVE LIABILITY TO YOU EXCEED
                    NGN10,000.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    4. BUSINESS AGREEMENT
                  </h5>
                  <p className="effective-document-p">
                    The Business Agreement is made on the day you accept the
                    Terms & condition before you invest/save your funds.
                  </p>
                  <p className="effective-document-p">
                    The Agreement is made between{" "}
                    <span>OVest (OSource Vestment Ltd)</span>
                    with <span> RC. Number 1776455</span> a Corporate Entity
                    duly registered with the Corporate Affairs Commission of
                    Nigeria hereinafter referred to as “The First Party”{" "}
                    <span> “The Investment Company”</span> which expression
                    shall where the context so admits include its
                    successor-in-title, executor, personal representative and
                    assignees of the ONE PART. AND <span>You </span> (user of
                    the OVest app, website, platform) hereinafter referred to as
                    the <span> “OVestor” </span>which expression shall where the
                    context so admits includes its successor-in-title,
                    executors, personal representatives and assigns of the OTHER
                    PART.
                  </p>
                  <p className="effective-document-p">
                    <span>WHEREAS:</span>
                    <p className="effective-document-p">
                      1. The First Party is an{" "}
                      <span>Investment and Funds Management Company</span> in
                      the business of Money Market (Foreign Exchange & Crypto
                      Trading) and running of other investment opportunities
                      offered by the industry.
                    </p>{" "}
                    <p className="effective-document-p">
                      2. That the First Party{" "}
                      <span>(The Investment Company)</span> opens the
                      opportunity for willing interested members to enjoy the
                      benefit ingrained in the Money Market by investing their
                      capital with her.
                    </p>{" "}
                    <p className="effective-document-p">
                      3. The <span>OVestor</span> desirous of reaping the
                      benefits in the Foreign Exchange Market (Money Market)
                      willfully entered the business agreement with the First
                      Party to invest capital for an agreed Return on Investment
                      at an agreed time.
                    </p>{" "}
                    <p className="effective-document-p">
                      4. The <span>OVestor</span> has negotiated with the First
                      Party, and desirous of investing in the same foreign
                      exchange business by paying an agreed capital into the
                      trade.
                    </p>
                    <p className="effective-document-p">
                      5. Both parties{" "}
                      <span>(The Investment Company and the OVestor)</span>
                      mutually agree to venture into a business relationship
                      upon receipt of payment of an agreed capital investment
                      sum, aimed at realizing and maximizing the full benefits
                      and investments opportunities offered by the industry
                    </p>
                    <p className="effective-document-p">
                      6. The parties{" "}
                      <span>(The Investment Company and the OVestor)</span>
                      have agreed to do business under the terms and conditions
                      hereunder.
                    </p>
                    <span>IT IS HEREBY AGREED BY THE PARTIES AS FOLLOWS:</span>
                    <p>
                      1. In furtherance to the above recital, the OVestor shall
                      advance an Investment Capital Sum of money (based on the
                      client’s choice of investment plan) into the Company’s
                      Account provided by the First Party (the receipt of the
                      said amount of money will be acknowledged once received).
                    </p>
                    <p>
                      2. That the phase of the transaction shall span for the
                      duration of{" "}
                      <span>
                        1 Month and above for Savest, 3 months for SiIvest and 6
                        months for Goldvest plans{" "}
                      </span>
                      (effective from the date the investment plan was initiated
                      to the due date).
                    </p>
                    <p>
                      3. Where the <span>OVestor</span> desires to complement
                      his/her invested Capital on the account record created for
                      the OVestor, s/he must signify his/her intentions within a
                      5 (FIVE) business days from the day the principal
                      investment sum was paid and acknowledged, hence the
                      complemented sum and the principal invested capital will
                      be the basis of payment on the next payment date. Failure
                      to complement the principal invested capital within five
                      business days, the OVestor will be estopped from
                      complementing to his/her principal investment, therefore
                      any payment made after the 5 business days will be the
                      basis of another investment regime.
                    </p>
                    <p>
                      4. The <span>OVestor</span> shall be entitled to a certain
                      percentage of his/her total Investment Capital as his/her
                      investment profit otherwise known as “RETURN ON INVESTMENT
                      (ROI)” which shall be due for maturity either monthly,
                      three months or after SIX (6) Months. The Breakdown of the
                      monthly earnings (capital and interest ) which makes up
                      the Total Return o Investment for each of the investment
                      plan I stated below:
                    </p>
                    <p>
                      <span>SAVEST PLAN</span>
                      <p className="effective-document-p">
                        For the fixed plan: 7% ROI monthly till the due date{" "}
                      </p>{" "}
                      <p className="effective-document-p">
                        For the flexible plan: 3.5% ROI every 15 days till due
                        date
                      </p>{" "}
                      <span>SILVEST PLAN</span>
                      <p className="effective-document-p">
                        Month 1: 15% ROI Month 2: 15%
                      </p>
                      <p className="effective-document-p">
                        ROI Month 3: 20% ROI + CAPITAL
                      </p>
                    </p>
                    <p>
                      <span> GOLDVEST PLAN</span>
                      <p className="effective-document-p">Month 1: 20% ROI</p>
                      <p className="effective-document-p"> Month 2: 20% ROI</p>
                      <p className="effective-document-p"> Month 3: 20% ROI</p>
                      <p className="effective-document-p"> Month 4: 20% ROI</p>
                      <p className="effective-document-p"> Month 5: 20% ROI</p>
                      <p className="effective-document-p">
                        {" "}
                        Month 6: 25% ROI + CAPITAL
                      </p>
                      <p className="effective-document-p">
                        The is to be paid to the bank account as furnished by
                        the OVestor during the stipulated period as agreed by
                        both parties,
                      </p>
                    </p>
                    <div>
                      <p className="effective-document-p">
                        5. The OVestor at the due maturity date has the
                        following options to decide from;
                      </p>{" "}
                      <p>
                        a. Withdraw the whole Capital invested plus the Profit
                        Accrued (ROI),
                      </p>{" "}
                      <p>
                        b. Withdraw only the Profit Accrued (ROI Alone) monthly,
                      </p>
                      <p>
                        c. Invest the whole Capital invested plus the Profit
                        Accrued (ROI)
                      </p>
                      <p>
                        d. Invest only the Profit Accrued (ROI Alone), e. Top Up
                        the investment sum.
                      </p>
                    </div>{" "}
                    <p>
                      6. Where the <span> OVestor</span> desires to collect
                      his/her capital and accrued interest or rollover his/her
                      capital and the accrued interest at the expiration of the
                      agreed period, he/she shall notify the First Party of
                      his/her intention five (5) days before the day he/she will
                      be due for payment via a mail or any means of
                      communication and such must be acknowledged. Failure to
                      notify the First Party of the intention may result to
                      delay in withdrawal and or the Capital and accrued sum
                      will automatically be rolled over.
                    </p>
                    <p>
                      7. The <span>OVestor</span> may appoint a representative
                      for the purpose of representing and liaising with the
                      First Party on his/her behalf during any period of his/her
                      absence to give effect to any part of the agreement as the
                      <span> OVestor</span> would have done himself/herself. The
                      appointment and authorization of this third party at the
                      instance of the <span>OVestor</span> must be put in
                      writing in form of a letter or a Power of Attorney (Duly
                      Executed) to be directed to the First party and the First
                      Party must acknowledge and agree to before the
                      representative can act on behalf of the{" "}
                      <span>OVestor.</span>
                    </p>
                    <p>
                      8. The First Party shall manage trade and keep proper
                      record of the Money Market trading activities most
                      especially the investment records(s) of the{" "}
                      <span>OVestor.</span>
                    </p>
                    <p>
                      9. The First Party shall not be liable for any claim or
                      action brought by any third party against the{" "}
                      <span>OVestor.</span>
                    </p>
                    <p>
                      10. The <span>OVestor</span> shall not be liable for any
                      claim or action brought by any third party against the
                      First Party.
                    </p>
                    <p>
                      11. The First Party agrees to indemnify the{" "}
                      <span>OVestor</span> against all losses whatsoever arising
                      from the transaction, provided the First Party is
                      negligent in discharge of its duties and dealings in the
                      transaction.
                    </p>
                    <p>
                      12. The <span>OVestor</span> cannot withdraw his/her
                      capital and interest until the due date in which the
                      transaction will elapse.
                    </p>
                    <p>
                      13. Notwithstanding paragraph 12, where the {""}
                      <span>OVestor</span> elect to terminate the agreement
                      before the due date, he/she will only be entitled to 75%
                      of his/her Capital sum with no accrued interest/profit.
                      The 25% will serve to cushion the effect of damages
                      suffered by the First Party for abruptly terminating the
                      agreement at the instance of the <span>OVestor.</span>
                    </p>
                    <p>
                      14. Where the transaction is to be determined by the {""}
                      <span>OVestor</span> before the due date, the First Party
                      shall be entitled to a 3 days’ notice.
                    </p>
                    <p>
                      15. In the event that the transaction is determined by the
                      First Party before the mutually agreed due date, the {""}
                      <span>OVestor</span> shall be entitled to his/her
                      investment capital and accruable interest for that month.
                    </p>
                    <p>
                      16. The payment with respect to paragraph 15 shall be paid
                      within 14 days.
                    </p>
                  </p>
                </div>
                <div>
                  <h5 className="effective-document-h5">CONFIDENTIALITY</h5>
                  <p className="effective-document-p">
                    The parties mutually agree to maintain confidentiality with
                    respect to details of the Business Agreement. Each party
                    further agrees to maintain in confidence all proprietary
                    information to include but not limited to all financial,
                    commercial, technical and other information relating to the
                    goodwill of the parties, received from the one another
                    during the pendency of the transaction.
                  </p>
                </div>
                <div>
                  <h5 className="effective-document-h5">AMENDMENTS</h5>
                  <p className="effective-document-p">
                    Any of the parties involved in the transaction may request
                    changes to the Business Agreement. Any modifications to the
                    Business Agreement must be mutually agreed by the parties
                    and shall be duly incorporated by a written instrument and
                    effective when executed and signed by all the parties to the
                    Business Agreement.
                  </p>
                </div>
                <div>
                  <h5 className="effective-document-h5">ARBITARTION CLAUSE</h5>
                  <p className="effective-document-p">
                    Any dispute, claim and other matters arising from the
                    provisions of the Business Agreement predicated upon the
                    transactional relationship between the parties or the breach
                    thereof, (“disputes”) shall first be submitted to
                    negotiation and may, failing resolution, then be subject to
                    arbitration as set forth below; The First Party shall
                    appoint an executive officer to meet the OVestor for the
                    purpose of resolving the dispute. If the parties’ are able
                    to reach an agreement, the dispute will be deemed resolved.
                    If after Seven (7) business days from the date the dispute
                    arose and the negotiation by the parties prove unsuccessful
                    in whole or in part, the parties may request that the
                    dispute or any part of it which remains unresolved shall be
                    set down for arbitration in accordance with the provisions
                    of the Arbitration and Conciliation Act CAP 19 Laws of the
                    Federation of Nigeria 1990, and such disputes shall be
                    arbitrated upon. Any award rendered pursuant to arbitration
                    may include reasonable Attorneys’ fees and cost shall be
                    final and binding upon the parties, and judgments may be
                    entered upon it in a court of competent jurisdiction.
                    APPLICABLE LAW
                  </p>
                </div>
                <div>
                  <h5 className="effective-document-h5">APPLICABLE LAW</h5>
                  <p className="effective-document-p">
                    The Laws of the Federal Republic of Nigeria shall govern the
                    construction, interpretation and enforcement of the
                    Memorandum of Understanding.
                  </p>
                </div>
                <div>
                  <h5 className="effective-document-h5">5. Termination</h5>
                  <p className="effective-document-p">
                    Each of us can end this agreement at any time, and it is
                    subject to the maturity of all plans. OVest may terminate or
                    suspend your access to OVest at any time, with prior notice
                    to you if your account is found to be fraudulent. OVest will
                    fully cooperate with any law enforcement authorities or
                    court order requesting or directing us to disclose the
                    identity of anyone posting, publishing, or otherwise making
                    available any User information, emails, or other materials
                    that are believed to violate these Terms of Use. Any
                    suspension, termination, or cancellation shall not affect
                    your obligations to OVest under these Terms of Use
                    (including but not limited to ownership, indemnification,
                    and limitation of liability), which by their sense and
                    context are intended to survive such suspension,
                    termination, or cancellation.
                  </p>
                </div>
                <div>
                  <h5 className="effective-document-h5">
                    6. Dispute Resolution
                  </h5>
                  <p className="effective-document-p">
                    If there is a legal dispute, it will take place in Federal
                    High Courts under Nigerian Law. You agree that these Terms
                    of Use shall be governed by and interpreted in accordance
                    with the laws of the Federal Republic of Nigeria.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    7. OVest "Dos" and "Don'ts”
                  </h5>
                  <p className="effective-document-p">
                    OVest grants you a license to use our Website and mobile
                    applications so far you comply with all our rules.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    7.1 Dos: You agree that you will:
                  </h5>
                  <p className="effective-document-p">
                    <p>
                      1. Comply with all applicable laws, including, without
                      limitation, privacy laws, intellectual property laws,
                      anti-spam laws, export control laws, tax laws, and
                      regulatory requirements;
                    </p>
                    <p>
                      2. Provide accurate information to us, whether reported
                      directly or through a third party who you authorize, and
                      keep it updated;
                    </p>
                    <p>
                      3. Use the services solely for your personal,
                      non-commercial use;
                    </p>
                    <p>
                      4. Use your real name on your profile and keep your
                      password confidential;
                    </p>
                    <p>5. Use the Services in a professional manner.</p>
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    7.2 Don’ts: You agree you won't:
                  </h5>
                  <div className="effective-document-p">
                    <p>
                      1. Circumvent, disable, or otherwise interfere with
                      security-related features of OVest or features that
                      prevent or restrict use or copying of any content or User
                      information
                    </p>
                    <p>
                      2. Upload, email, transmit, provide, or otherwise make
                      available:
                    </p>
                    <p>
                      ● Any User information which you do not have the lawful
                      right to use, copy, transmit, display, or make available
                      (including any User information that would violate any
                      confidentiality or fiduciary obligations that you might
                      have with respect to the User information); or
                    </p>
                    <p>
                      ● any User information that infringes the intellectual
                      property rights of, or violates the privacy rights of, any
                      third-party (including without limitation copyright,
                      trademark, patent, trade secret, or other intellectual
                      property right, moral right, or right of publicity); or
                    </p>
                    <p>
                      ● unsolicited or unauthorized advertising, promotional
                      materials, junk mail, spam, chain letters, pyramid
                      schemes, or any other form of solicitation; or
                    </p>
                    <p>
                      ● any personal information that is unlawful, obscene,
                      harmful, threatening, harassing, defamatory, or hateful,
                      or that contain objects or symbols of hate, invade the
                      privacy of any third-party, contain nudity, are deceptive,
                      threatening, abusive, inciting of unlawful action, or are
                      otherwise objectionable in the sole discretion of OVest;
                      or
                    </p>
                    <p>
                      ● any personal information that contains software viruses
                      or any other computer code, files, or programs designed to
                      (i) interrupt, destroy, or limit the functionality of any
                      computer software; or (ii) interfere with the access of
                      any user, host or network, including without limitation
                      overloading, flooding, spamming, mail-bombing, or sending
                      a virus to OVest; or
                    </p>
                    <p>
                      ● any personal information that includes code that is
                      hidden or otherwise surreptitiously contained within the
                      User information;
                    </p>
                    <p>
                      ● Use any meta tags or other hidden text or metadata
                      utilizing a OVest name, trademark, URL or product name;
                    </p>
                    <p>
                      ● Forge any TCP/IP packet header or any part of the header
                      information in any posting, or in any way use OVest to
                      send altered, deceptive, or false source- identifying
                      information;
                    </p>
                    <p>
                      ● Interfere with or disrupt (or attempt to interfere with
                      or disrupt) any OVest OVestb page, server, or network, or
                      the technical delivery systems of OVest's providers, or
                      disobey any requirements, procedures, policies, or
                      regulations of networks connected to OVest.
                    </p>
                    <p>
                      ● Attempt to probe, scan, or test the vulnerability of any
                      OVest system or network or breach or impair or circumvent
                      any security or authentication measures protecting OVest;
                    </p>
                    <p>
                      ● Attempt to decipher, decompile, disassemble, or
                      reverse-engineer any of the software used to provide
                      OVest;
                    </p>
                    <p>
                      ● Attempt to access, search, or meta-search OVest or
                      content thereon with any engine, software, tool, agent,
                      device, or mechanism other than software and/or search
                      agents provided by OVest or other generally available
                      third-party web browsers, including without limitation any
                      software that sends queries to OVest to determine how a
                      Website or OVestb page ranks;
                    </p>
                    <p>
                      ● Violate the terms of service or any other rule or
                      agreement applicable to you or OVest's inclusion in,
                      reference to, or relationship with any third party or
                      third-party site or service, or your use of any such
                      third-party site or service; Collect or store personal
                      information about other users without their express
                      permission;
                    </p>
                  </div>
                </div>

                <div>
                  <h5 className="effective-document-h5">8. General Terms</h5>
                  <p className="effective-document-p">
                    In the event that any provision in these Terms of Use is
                    held to be invalid or unenforceable, the remaining
                    provisions will remain in full force and effect. The failure
                    of a party to enforce any right or provision of these Terms
                    of Use will not be deemed a waiver of such right or
                    provision. You may not assign this Agreement (by operation
                    of law or otherwise) without the prior written consent of
                    OVest, and any prohibited assignment will be null and void.
                    OVest may assign this Terms of Use Agreement or any rights
                    hereunder without your consent. The relationship of the
                    parties under these Terms of Use is that of independent
                    contractors, and these Terms of Use will not be construed to
                    imply that either party is the agent, employee, or joint
                    venture of the other. Note that if you become a Client, the
                    relationship of the parties will be governed by these Terms
                    of Use, our Privacy Policy and any additional terms to which
                    you agree when you create and fund an OVest account. OVest
                    reserve the right to change this Agreement by posting a
                    revised Terms of Use and OVest agree that changes cannot be
                    retroactive. If you don't agree with these changes, you must
                    stop using OVest. You agree the only way to provide us legal
                    notice is at the address provided in Section 9.5.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    9. International Use
                  </h5>
                  <p className="effective-document-para">
                    <span>
                      {" "}
                      OVest is available for use in Nigeria and overseas.
                    </span>
                  </p>
                  <p className="effective-document-p">
                    OVest is available for use within and outside Nigeria.
                    Hence, you can use the OVest website and application
                    anywhere in the world. All you need to do is to select your
                    country from the list of countries.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">9. Miscellaneous</h5>
                  <p className="effective-document-p">
                    This Agreement takes priority over previous agreements
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">10. Miscellaneous</h5>
                  <p className="effective-document-p">
                    This Agreement takes priority over previous agreements
                  </p>
                </div>
                <div>
                  <h5 className="effective-document-h5">
                    10.1. Integration & Severability
                  </h5>
                  <p className="effective-document-p">
                    This Agreement is the entire agreement between you and us
                    with respect to OVest, and your use of our Website and
                    mobile app, and supersedes all prior or contemporaneous
                    communications and proposals (whether oral, written or
                    electronic) between you and us. If any provision of this
                    Agreement is found to be unenforceable or invalid, that
                    provision will be limited or eliminated to the minimum
                    extent necessary so that this Agreement will otherwise
                    remain in full force and effect. The failure of either party
                    to exercise in any respect any right provided for herein
                    shall not be deemed a waiver of any further rights
                    hereunder. Investment recommendations are made to Clients on
                    an individual basis and may differ based on specific
                    circumstances.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    10.2 Advice may differ
                  </h5>
                  <p className="effective-document-p">
                    You understand and agree that OVest act as an investment
                    advisor for Clients and will continue to do so. OVest and
                    our personnel may make recommendations and take action for
                    Clients that may differ from the recommendations OVest give
                    to you or the action OVest take on your behalf. In addition,
                    our personnel may take actions for their own accounts based
                    on their own investment situations that differ from the
                    recommendations OVest give you or actions OVest take on your
                    behalf.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    10.3. Communication: Any notice or communication will be in
                    writing by email
                  </h5>
                  <p className="effective-document-p">
                    You agree that these Terms of Use and the rules,
                    restrictions, and policies contained herein, and OVest's
                    enforcement thereof, are not intended to confer and do not
                    confer any rights or remedies on any person other than you
                    and OVest. These Terms of Use together with the OVest's
                    Privacy Policy and Client Agreement (if applicable)
                    constitute the entire agreement between OVest and you with
                    respect to the subject matter hereof. Any notice or other
                    communication to be given hereunder will be in writing and
                    given by (a) OVest via email (in each case to the address
                    that you provide), or (b) you via email to{" "}
                    <a href="mailto:hello@myovest.com">hello@myovest.com.</a>
                    or to such other addresses as OVest may specify in writing.
                    The date of receipt shall be deemed the date on which such
                    notice is transmitted.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    10.4 Feedback: We welcome your feedback!
                  </h5>
                  <p className="effective-document-p">
                    Your feedback is welcome and encouraged. You may submit
                    feedback by emailing us at{" "}
                    <a href="mailto:hello@myovest.com">hello@myovest.com</a>
                    You agree, however, that (i) by submitting unsolicited ideas
                    to OVest or any of its employees or representatives, by any
                    medium, including but not limited to email, written, or oral
                    communication, you automatically forfeit your right to any
                    intellectual property rights in such ideas; and (ii) such
                    unsolicited ideas automatically become the property of
                    OVest. You hereby assign and agree to assign all rights,
                    title, and interest you have in such feedback and ideas to
                    OVest together with all intellectual property rights
                    therein. In addition, you warrant that all moral rights in
                    any feedback have been waived, and you do hereby waive any
                    such moral rights.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                    10.5. Questions: If you have any questions
                  </h5>
                  <p className="effective-document-p">
                    This document constitutes OVest's complete Terms of Service
                    for OVest and related services. If you have questions about
                    these Terms of Services or about OVest or content thereon,
                    please contact OVest at{" "}
                    <a href="mailto:hello@myovest.com">hello@myovest.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  );
};

export default TermsOfUse;
